<ion-header>
 <div class="header_div ion-margin-bottom" color="primary">
    <div class="container">
      <div class="logo-container" *ngIf="!accountImage">
        <img src="assets/logos/social-dash-logo-with-white-circle.png" alt="Social Dash Logo" />
      </div>
      <ion-avatar *ngIf="accountImage" class="profile-logo">
        <img [src]="accountImage" alt="User Logo" />
      </ion-avatar>
      <div *ngIf="isMenuExpanded">
        <div class="username" *ngIf="user">{{ account.name }}</div>
        <div class="environment" *ngIf="isDev">development</div>
      </div>
    </div>
  </div>
</ion-header>
<ion-content>
  <div *ngIf="isSelectingAccount" class="selecting-overlay">
    <div class="selecting-message">Please refresh the browser.</div>
  </div>
  <ion-list>
    <!-- Ungrouped Items -->
    <div *ngFor="let page of pages">
      <div *ngIf="!page.group && isPageVisible(page.class)">
        <ion-item lines="none" [routerLink]="page.url ? [page.url] : null" [queryParams]="page.queryParams" (click)="handlePageClick(page)" routerDirection="forward" button>
          <div slot="start" class="ic_div">
            <ion-icon color="primary" class="icon" [src]="page.icon.includes('/') ? page.icon : null" [name]="!page.icon.includes('/') ? page.icon : null"></ion-icon>
          </div>
          <ion-label *ngIf="isMenuExpanded">{{ page.title }}</ion-label>
        </ion-item>
      </div>
    </div>

    <!-- Grouped Items -->
    <ng-container *ngFor="let group of getGroups()">
      <div *ngIf="isGroupVisible(group)">
        <ion-item-divider>
          <ion-label>{{ group }}</ion-label>
        </ion-item-divider>
        <div *ngFor="let page of pages">
          <div *ngIf="page.group === group && isPageVisible(page.class)">
            <ion-item lines="none" [routerLink]="page.url ? [page.url] : null" [queryParams]="page.queryParams" (click)="handlePageClick(page)" routerDirection="forward" button>
              <div slot="start" class="ic_div">
                <ion-icon color="primary" class="icon" [src]="page.icon.includes('/') ? page.icon : null" [name]="!page.icon.includes('/') ? page.icon : null"></ion-icon>
              </div>
              <ion-label *ngIf="isMenuExpanded">{{ page.title }}</ion-label>
            </ion-item>
          </div>
        </div>
      </div>
    </ng-container>
  </ion-list>
</ion-content>